export const CUSTOMER_STATUSES = ["Active", "Inactive", "Prospect"];
export const PROJECT_STATUSES  = ["Active", "Inactive", "Closed"];

export const CUST_STATUS_PILL = {
  Active:   "pjv2-pill--active",
  Inactive: "pjv2-pill--inactive",
  Prospect: "pjv2-pill--prospect",
};

export const PROJ_STATUS_PILL = {
  Active:   "pjv2-pill--active",
  Inactive: "pjv2-pill--inactive",
  Closed:   "pjv2-pill--closed",
};
